import Base, {clearLeg, isSeriesCompleted} from "./base";
import {mergeDeep} from "../utils/index";

function sumScore(sectors) {
  return sectors.reduce((score, shot) => {
    if (shot.length) score += shot[0] * shot[1]
    return score
  }, 0)
}

function isComplete(target, sectors) {
  const score = sumScore(sectors)
  return score >= target * 3
}

class Game extends Base {

  sectors = [
    20,
    19,
    18,
    17,
    16,
    15,
    25,
  ]

  constructor(store, default_game, urls = window.URLS, type_game = 'cricket') {
    super(store, urls)
    if (type_game === this.get('game').type_game) {
      this.set('game', mergeDeep({
        data: [[]],
      }, default_game, this.get('game')))
      this.set('inputSS', {
        darts: 0,
        sectors: []
      })
      this.restoreSelected()
    }
  }

  get maxSeries() {
    return this.data.length + 1
  }

  getLastPosition() {
    const leg = this.data
    let p = this.first
    let i = 0
    leg.forEach((series, j) => {
      if (series[+!this.first]?.sectors?.length) {
        p = +!this.first
        i = j
      } else if (series[this.first]?.sectors?.length) {
        p = this.first
        i = j
      }
    })
    return [i, p]
  }

  getSelected() {
    const leg = this.data
    let [i, p] = this.getLastPosition()
    let shot = 0
    const [darts_1, darts_2] = this.getDarts(leg)
    if (darts_1 && darts_1 % 3) {
      p = 0
    } else if (darts_2 && darts_2 % 3) {
      p = 1
    } else if (darts_1 && darts_2 && (darts_1 === darts_2)) {
      i += 1
      p = this.first
    } else if (darts_1 === darts_2) {
      p = this.first
    } else {
      p = darts_1 > darts_2 ? 1 : 0
    }

    shot = leg[i]?.[p]?.sectors?.length ?? 0
    return [i, p, '', shot]
  }

  getWinnerNumberByLeg(leg) {
    const win_player_1 = this.sectors.every((sector) => this.completeSector(leg, sector, 0))
    const win_player_2 = this.sectors.every((sector) => this.completeSector(leg, sector, 1))

    if (win_player_1 && win_player_2) return 0
    if (win_player_1) return 1
    if (win_player_2) return 2
  }

  getDataAndScore(ss) {
    const legs = this.get('game').data
    const [i, p] = this.get('selected');
    const leg = legs.at(-1)
    const series = leg.at(i) || [{}, {}]
    series[p] = ss
    leg[i] = series
    legs[legs.length - 1] = clearLeg(leg)
    return [legs, this.calculateTotalScore(legs)]
  }

  preSave(body) {
    body.data.at(-1).forEach(series => {
      series.forEach(ss => {
        if (ss.sectors?.length) {
          while (ss.sectors?.length < 3) ss.sectors.push([0, 0]);
          if (ss.darts !== undefined) ss.darts = 3
        }
      })
    })

    this.set('inputSS', {
      darts: 0,
      sectors: []
    })
    return body
  }

  calculateScore(leg) {
    const closed = this.sectors.reduce((acc, sector) => {
      acc[0][sector] = []
      acc[1][sector] = []
      return acc
    }, [{}, {}]);

    const scoresSS = leg.reduce((scores, series) => {
      [this.first, +!this.first].forEach((p) => {
        const ss = series[p]
        ss.sectors?.forEach(([shot, m]) => {
          if (!shot) return
          closed[p][shot].push([shot, m])
          if (isComplete(shot, closed[p][shot]) && !isComplete(shot, closed[+!p][shot])) {
            const target = shot * 3
            const sum = sumScore(closed[p][shot])
            scores[p][shot] = sum - target
          }
        })
      })
      return scores
    }, [{}, {}])

    return scoresSS.reduce((scores, scoresSS, i) => {
      Object.keys(scoresSS).forEach((shot) => {
        scores[i] += scoresSS[shot]
      })
      return scores
    }, [0, 0])
  }

  getSectorsBySector(leg, sector, p) {
    return leg.reduce((acc, series) => {
      if (series[p]?.sectors) {
        const sectors = series[p].sectors.filter(([s]) => sector === s)
        if (sectors.length) acc.push(...sectors)
      }
      return acc
    }, [])
  }

  inputSector(sector, m = 1) {
    const inputSS = this.get('inputSS')

    if (sector != null) {
      inputSS.sectors.push([sector, m])
    } else {
      inputSS.sectors = inputSS.sectors.slice(0, -1)
    }
    const game = this.get('game')
    const [data] = this.getDataAndScore(inputSS)
    game.data = data
    this.set('game', game)
    // console.log(inputSS, sector, data);
  }

  completeSector(leg, sector, p) {
    return isComplete(sector, this.getSectorsBySector(leg, sector, p))
  }

  completedGame() {
    const {end_time} = this.get('game')
    return !!end_time
  }

}

export default Game